import * as React from 'react';
import Link from '@src/components/link';
import InnerFloatRightStore from './store';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';
import { handleDownloadLinkClick } from '@src/utils/download-link';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const CommunityChannels = ({ compact = false }) => (
  <div className={cx(compact && styles.community)}>
    <div className={styles.btns}>
      <button type="button" className={cx(styles.channel, !compact && styles.wx)} aria-label="查看微信公众号二维码">
        <span className={styles.hoverOpenQrcode}>
          <img src={require('./images/qrcode-wx.jpg')} alt="微信公众号二维码" />
          <span className={styles.hoverOpenQrcodeTitleWx} />
        </span>
      </button>
      <button type="button" className={cx(styles.channel, !compact && styles.qw)} aria-label="查看官方客服二维码">
        <span className={styles.hoverOpenQrcode}>
          <img src={require('./images/qrcode-qw.jpg')} alt="官方客服二维码" />
          <span className={styles.hoverOpenQrcodeTitleQw} />
        </span>
      </button>
    </div>
  </div>
);

const InnerFloatRight = ({ store }) => {
  store.use();
  const shouldRender = store.show && store.isOpen;

  return (
    <div className={cx(styles.root, store.show && styles.show)}>
      {shouldRender && (
        <div className={cx(styles.floatRight, { [styles.floatRightType2]: store.type === 2 })}>
          {store.type === 2 && <div className={styles.downloadTitle}>扫码下载游戏</div>}
          <div className={styles.qrcodeBox}>
            {store.type === 1 ? (
              <img src={require('./images/qrcode.png')} alt="小程序二维码" />
            ) : (
              store.downloadUrl.floatQrcode && <iframe src={store.downloadUrl.floatQrcode} title="内页侧边扫码下载游戏" />
            )}
            {store.type === 2 && <span className={styles.scanLine} aria-hidden="true" />}
          </div>
          {store.type === 2 && (
            <div className={styles.download}>
              {Object.keys(store.download).map(key => {
                const downloadLink = store.downloadUrl[store.download[key].url];
                return (
                  <Link
                    key={key}
                    className={cx(styles.downloadBtn, styles[key])}
                    href={downloadLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={store.download[key].name}
                    onClick={event =>
                      handleDownloadLinkClick(event, downloadLink, () => {
                        if (key === 'android') $$tracker.clickDownloadAndroid('内页侧边');
                        if (key === 'ios') $$tracker.clickDownloadIOS('内页侧边');
                        if (key === 'pc') $$tracker.clickDownloadPC('内页侧边');
                      })
                    }
                  />
                );
              })}
            </div>
          )}
          {store.type === 2 && (
            <div className={styles.links}>
              <Link className={styles.serviceLink} href={store.supportUrl} target="_blank" rel="noopener noreferrer" aria-label="客服专区">
                客服专区
              </Link>
              <Link
                className={styles.auditionLink}
                onClick={() => {
                  store.gotoIndex(4);
                }}
              >
                视听中心
              </Link>
            </div>
          )}
          <CommunityChannels compact={store.type === 2} />
        </div>
      )}
    </div>
  );
};

export default wrapStore(InnerFloatRight, InnerFloatRightStore);
